import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const StatusReviewPrivateIcon: FC<IconProps> = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2 4.25V3.25C1.44772 3.25 1 3.69772 1 4.25H2ZM20 4.25H21C21 3.69772 20.5523 3.25 20 3.25V4.25ZM10.0196 18.4571C10.4101 18.0666 10.4101 17.4334 10.0196 17.0429C9.62908 16.6524 8.99592 16.6524 8.60539 17.0429L10.0196 18.4571ZM7.0625 20L6.35539 20.7071C6.74592 21.0976 7.37908 21.0976 7.76961 20.7071L7.0625 20ZM4.8125 17.75L5.51961 17.0429C5.33207 16.8554 5.07772 16.75 4.8125 16.75V17.75ZM2 17.75H1C1 18.3023 1.44772 18.75 2 18.75V17.75ZM6.5 12.25C5.94772 12.25 5.5 12.6977 5.5 13.25C5.5 13.8023 5.94772 14.25 6.5 14.25V12.25ZM9.875 14.25C10.4273 14.25 10.875 13.8023 10.875 13.25C10.875 12.6977 10.4273 12.25 9.875 12.25V14.25ZM6.5 7.75C5.94772 7.75 5.5 8.19772 5.5 8.75C5.5 9.30228 5.94772 9.75 6.5 9.75V7.75ZM13.25 9.75C13.8023 9.75 14.25 9.30228 14.25 8.75C14.25 8.19772 13.8023 7.75 13.25 7.75V9.75ZM19 9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9H19ZM2 5.25H20V3.25H2V5.25ZM8.60539 17.0429L6.35539 19.2929L7.76961 20.7071L10.0196 18.4571L8.60539 17.0429ZM7.76961 19.2929L5.51961 17.0429L4.10539 18.4571L6.35539 20.7071L7.76961 19.2929ZM4.8125 16.75H2V18.75H4.8125V16.75ZM3 17.75V4.25H1V17.75H3ZM6.5 14.25H9.875V12.25H6.5V14.25ZM6.5 9.75H13.25V7.75H6.5V9.75ZM19 4.25V9H21V4.25H19Z'
      fill='#A0A1AD'
    />
    <circle cx='18' cy='18' r='6' fill='#3B42A5' />
    <path
      d='M18 20.75C20.2091 20.75 22 18 22 18C22 18 20.2091 15.25 18 15.25C15.7909 15.25 14 18 14 18C14 18 15.7909 20.75 18 20.75Z'
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M18 18H18.01'
      stroke='white'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default StatusReviewPrivateIcon
